<div id="kt_header" class="header header--fixed" *transloco="let t; read: 'app.navbar'">
  <div class="header__container">
    <!-- LEFT AREA -->
    <div class="header__menu">
      <a class="header__logo-mobile" (click)="navigateToDashboard()">
        <app-svg-icon [icon]="'assets/images/logo-small.svg'" [blank]="true" />
      </a>

      <h2 class="header__breadcrumb">
        <app-breadcrumb />
      </h2>
    </div>

    <!-- RIGHT AREA -->
    <div class="header__topbar">
      <div class="topbar__item">
        <div class="topbar__utilities">
          <app-theme-switcher />
          <app-language-dropdown />
        </div>

        <!-- TOKENS -->
        <a
          class="topbar__dropdown topbar__dropdown--tokens"
          [routerLink]="'/earn'"
          appDisableLightTheme
        >
          <div class="tokens">
            <span class="tokens__icon">
              <img src="./assets/images/bfcoin.png" alt="BF Coins" />
            </span>
            <span class="tokens__amount">
              {{ tokensAmount$ | async }}
            </span>
          </div>
        </a>

        <!-- USER MENU -->
        <div class="topbar__dropdown topbar__dropdown--user" appDisableLightTheme>
          <div class="topbar__trigger" (click)="expandMenu()">
            <span class="topbar__avatar">
              <span class="symbol-label">
                @if (user$ | async; as user) {
                  {{ user | userCredentials: true }}
                }
              </span>
            </span>

            <span class="topbar__username">
              @if (user$ | async; as user) {
                {{ user | userCredentials }}
              }
            </span>

            <app-svg-icon
              class="topbar__chevron"
              [ngClass]="{ 'topbar__chevron--active': menuVisible }"
              [icon]="'assets/images/header/chevron.svg'"
              [blank]="true"
            />
          </div>

          @if (menuVisible) {
            <div class="topbar__dropdown-menu">
              <a (click)="prompt(); menuVisible = false">
                {{ t("dropdown") }}
              </a>
            </div>
          }
        </div>
      </div>
    </div>

    <button class="header__hamburger" (click)="toggleSidebar()">
      @if (!isCollapsed) {
        <app-svg-icon [icon]="'assets/images/icon-hamburger.svg'" [blank]="true" />
      }
      @if (isCollapsed) {
        <app-svg-icon
          class="header__hamburger-icon--close"
          [icon]="'assets/images/icon-close.svg'"
          [blank]="true"
        />
      }
    </button>
  </div>
</div>

@if (showLogoutDialog) {
  <ng-container *transloco="let t; read: 'app.navbar'">
    <app-custom-dialog [hideCloseButton]="true" (dialogClose)="closeDialog()" [noPadding]="true">
      <div content class="logout-dialog">
        <app-svg-icon
          svgSize="40px"
          class="logout-dialog__icon"
          [icon]="'assets/images/alert.svg'"
          [blank]="true"
        />
        <h2 class="logout-dialog__title">{{ t("title") }}</h2>
        <p class="logout-dialog__desc">{{ t("heading") }}</p>
        <div class="logout-dialog__actions">
          <app-button class="c-button" size="large" type="secondary" (onClick)="closeDialog()">{{
            t("cancel")
          }}</app-button>
          <app-button class="c-button" size="large" type="primary" (onClick)="logout()">{{
            t("confirm")
          }}</app-button>
        </div>
      </div>
    </app-custom-dialog>
  </ng-container>
}
